import ActionTypes from '../constants/action-types';

export const getSubcovers = (args) => async (dispatch) => {
    await axios.post(`/api/get-subcovers`, { ...args })
        .then((response) => {
            dispatch({
                type: ActionTypes.SET_SUBCOVER,
                payload: response.data.data
            });
        })
        .catch((error) => {
            console.error({ error });
        });
};

export const setOnlinePresence = (payload) => ({
    type: ActionTypes.SET_ONLINE_PRESENCE,
    payload
});

export const addOnlinePresence = (payload) => ({
    type: ActionTypes.ADD_ONLINE_PRESENCE,
    payload
});

export const removeOnlinePresence = (payload) => ({
    type: ActionTypes.REMOVE_ONLINE_PRESENCE,
    payload
});

export const addChunkOnlinePresence = (payload) => ({
    type: ActionTypes.ADD_CHUNK_ONLINE_PRESENCE,
    payload
});


export const updateUserStore = (payload) => ({
    type: ActionTypes.UPDATE_USER_STORE,
    payload
});